import React from "react";

import { formatTimeMilli } from "components/utils";

import { CueTimeGlobalSC, CueTimeLocalSC, CueTimeWrapSC } from "./styled";

/**
 * Ниже этого расстояния до соседней реплики вторая строка налезет на её метку.
 *
 * Значение измерено на живой странице, а не выведено из размеров шрифта: пара строк занимает
 * ровно 28 пикселей. Расчёт давал 24, и на промежутке 24-28 метки успели бы наехать.
 */
const MIN_GAP_FOR_SECOND_LINE_PX = 30;

interface ICueTimeProps {
    /** Время реплики от начала папки, мс. */
    localMs: number;
    /** Время от начала всего видео, мс. `null` — смещение папки не пришло. */
    globalMs: number | null;
    showGlobal: boolean;
    side: "left" | "right";
    /** Расстояние до следующей реплики в пикселях; не задано — реплика последняя. */
    gapToNextPx?: number;
}

/**
 * Время реплики: от начала папки и, под ним, от начала всего видео.
 *
 * Один элемент на обе колонки. Раньше это были два почти одинаковых компонента, отличавшихся
 * единственной строкой (`right: 101%` против `left: 101%`), — править одно и то же в двух местах
 * значит рано или поздно развести колонки.
 */
export const CueTime = ({ localMs, globalMs, showGlobal, side, gapToNextPx }: ICueTimeProps) => {
    // На большом отдалении реплики стоят вплотную, и вторая строка наезжает на метку соседа.
    // Пропуск лечится зумом, наложение — нечитаемая каша.
    const roomForSecondLine =
        gapToNextPx === undefined || gapToNextPx >= MIN_GAP_FOR_SECOND_LINE_PX;

    return (
        <CueTimeWrapSC $side={side}>
            <CueTimeLocalSC title="От начала папки">{formatTimeMilli(localMs)}</CueTimeLocalSC>
            {showGlobal && roomForSecondLine ? (
                <CueTimeGlobalSC
                    title={
                        globalMs === null
                            ? "Смещение папки не пришло с сервера — время от начала видео посчитать не из чего"
                            : "От начала видео"
                    }
                >
                    {/* Прочерк, а не ноль и не пустота: ноль показал бы время первой папки для
                        любой другой, а пустая строка неотличима от выключённой настройки. */}
                    {globalMs === null ? "—:—:—" : formatTimeMilli(globalMs)}
                </CueTimeGlobalSC>
            ) : null}
        </CueTimeWrapSC>
    );
};
